export interface VehicleCompletion { completed: number; applicable: number }

export function VehicleConfigurationProgress({ completed, applicable }: VehicleCompletion) {
  const percent = applicable ? Math.min(100, Math.round(completed / applicable * 100)) : 0
  return <div data-vehicle-completion role="group" aria-label="Informations renseignées" className="flex shrink-0 items-center gap-2 text-slate-700 dark:text-slate-200">
    <div className="relative h-10 w-10 shrink-0 sm:h-12 sm:w-12">
      <svg viewBox="0 0 80 80" role="img" aria-label={`${percent} % des sections renseignées`} className="h-full w-full -rotate-90">
        <circle cx="40" cy="40" r="32" fill="none" stroke="#e2e8f0" strokeWidth="4" />
        <circle cx="40" cy="40" r="32" fill="none" stroke="#f97316" strokeWidth="4" strokeLinecap="round" strokeDasharray={`${percent / 100 * 201.06} 201.06`} />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-[10px] font-semibold tabular-nums sm:text-xs">{percent}%</span>
    </div>
    <div><p className="hidden text-[11px] font-semibold sm:block">Informations renseignées</p><p className="mt-0.5 text-[10px] text-slate-500 dark:text-slate-400"><strong>{completed} / {applicable}</strong><span className="sr-only sm:not-sr-only"> sections renseignées</span></p></div>
  </div>
}
